// extracted by mini-css-extract-plugin
module.exports = {"hubsContainer":"_39ace0","title":"_5e32ea","hubsGrid":"_95a175","categoryIitem":"_efe342","imageContainer":"_4bba14","image":"_fb6585"};